import { render } from "./MariaCiocanPage.vue?vue&type=template&id=51239aa4"
import script from "./MariaCiocanPage.vue?vue&type=script&lang=js"
export * from "./MariaCiocanPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__